var styles = {"box":"CodeInput_box_r57r8_1","label":"CodeInput_label_r57r8_6","error":"CodeInput_error_r57r8_27","input":"CodeInput_input_r57r8_33"};

export { styles as default };
//# sourceMappingURL=index.module.scss.js.map
